// HotelCard.tsx
import React from 'react';
import { Link } from 'react-router-dom';

// プロパティIDも受け取れるように拡張
export interface HotelCardData {
  propertyId: number;
  imageUrl: string;
  location: string;
  subLocation: string;
  area: {
    id: number;
    name: string;
    name_en: string;
  } | null;
  subAreas: {
    id: number;
    name: string;
    name_en: string;
  }[];
}

interface HotelCardProps {
  stayCardData: HotelCardData[];
}

export const HotelCard: React.FC<HotelCardProps> = ({ stayCardData }) => {
  // カードを2つずつの配列に分割する関数
  const chunkArray = <T,>(array: T[], size: number): T[][] => {
    const chunkedArr: T[][] = [];
    let index = 0;
    while (index < array.length) {
      chunkedArr.push(array.slice(index, size + index));
      index += size;
    }
    return chunkedArr;
  };

  // ここで受け取った stayCardData をチャンク化 (2個ずつ1行に表示)
  const cardRows = chunkArray(stayCardData, 2);

  return (
    <div>
      {cardRows.map((row, rowIndex) => (
        <div
          key={rowIndex}
          className="flex flex-col items-center md:flex-row md:justify-center md:mb-4"
        >
          {row.map((card, index) => (
            <div
              key={index}
              className="mb-8 md:mb-0 md:mx-[5px] md:max-w-[300px]"
            >
              <img
                src={card.imageUrl}
                alt="Neighborhood"
                className="w-full h-auto object-cover mb-4 md:max-w-[300px] md:max-h-[285px]"
              />
              <div>
                <div className="text-2xl underline text-start">
                  {card.location}
                </div>
                <div className="mb-4 text-start">{card.subLocation}</div>

                {/* area 情報の表示例 */}
                {/* {card.area && (
                  <div className="text-sm text-start">
                    {card.area.name}
                    {card.subAreas.map((sa) => sa.name).join(', ')}
                  </div>
                )} */}

                <div className="flex justify-start space-x-4">
                  {/* ここで propertyId を使って動的にパスを生成 */}
                  <Link
                    to={`/hotel/${card.propertyId}`}
                    className="border border-black px-4 py-2 inline-block"
                  >
                    Hotel Plan
                  </Link>
                  <Link
                    to={`/monthly/${card.propertyId}`}
                    className="border border-black px-4 py-2 inline-block"
                  >
                    Monthly Plan
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
